import React, { Component } from 'react';
import QualificationComponent from '../components/qualification/qualification.component'
class QualificationContainer extends Component {    
    render() {
        return (
            <section id="section-qualifications">
                <div className="container">
                    <div className="jumbotron">
                        <h1>Qualifications</h1>
                        <QualificationComponent title="Academic" items={this.props.data.Academic} />
                        <QualificationComponent title="Certifications" items={this.props.data.Certifications} />
                    </div>
                </div>
            </section>
        );
    }
}

export default QualificationContainer;



// WEBPACK FOOTER //
// ./src/containers/qualification.container.jsx